import { memo, useReducer, createContext } from 'react';
// @mui

//
import FeedbackDetails from './FeedbackDetails';
import FeedbackList from './FeedbackList';

/* ======================================================================================== */

const FeedbackContext = createContext({});

const initialValues = {
  open: false,
  visible: false,
  details: {},
  reply_details: {},
  readFlag: null
};

function reducer(state, action) {
  switch (action.type) {
    case 'OPEN_LIST_DRAWER':
      return action.data;
    case 'OPEN_DETAILS_DRAWER':
      return action.data;
    default:
      return initialValues;
  }
};

/* ======================================================================================== */
const Feedback = ({ primary, children }) => {
  const [state, commit] = useReducer(reducer, { initialValues });

  const toggleListDrawer = (visible) => (event) => {
    commit({
      type: 'OPEN_LIST_DRAWER',
      data: { open: visible }
    });
  };

  return (
    <FeedbackContext.Provider value={{ state, commit }}>
      <FeedbackList ct={FeedbackContext} />
      <FeedbackDetails ct={FeedbackContext} />
    </FeedbackContext.Provider>
  );
};

export default memo(Feedback);
